export function notEmpty<TValue>(
  value: TValue | null | undefined
): value is TValue {
  if (value === null || value === undefined) return false;
  const testDummy: TValue = value;
  return true;
}

export type Empty = null | undefined;

export function empty<T>(value: T | Empty): value is Empty {
  return !notEmpty(value);
}

export function hasIndex(arr: any[], i: number) {
  return arr[i] !== undefined;
}
